import { Loader as BaseLoader, LoaderProps as MantineLoaderProps, Stack } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';

import s from './Loader.module.scss';

type LoaderProps = {
  className?: string;
  fullHeight?: boolean;
  text?: string | null;
  size?: MantineLoaderProps['size'];
  color?: MantineLoaderProps['color'];
};

const Loader: React.FC<LoaderProps> = ({ className, fullHeight, text = 'Загрузка...', size, color }) => {
  return (
    <div className={cn(s.root, fullHeight && s['root_full-height'], className)}>
      <Stack gap="sm" align="center">
        <BaseLoader size={size} color={color} />
        {text && <Text size="md">{text}</Text>}
      </Stack>
    </div>
  );
};

export default React.memo(Loader);
